/**
 * 静态资源 / 第三方地址的读取方法。
 * 统一走 resourceRequest（不带业务头、失败会 reject），调用方需自行 try/catch 降级。
 *
 * @date 2026-10-14
 * @ai-generated true
 * @ai-tool Claude Code
 */
import resourceRequest from '../request/resourceRequest'

/**
 * 以纯文本读取远程文件（txt / md / html 等）。
 * responseType 设为 text，axios 不会尝试把内容当 JSON 解析。
 * @param {string} url 文件完整地址
 * @param {Object} [headers] 额外请求头（如 Accept）
 * @returns {Promise<string>}
 */
export async function getRemoteText(url, headers) {
  const res = await resourceRequest.get(url, { responseType: 'text', headers })
  return res.data
}

/**
 * 以二进制读取远程文件（音频等）。
 * @param {string} url 文件完整地址
 * @returns {Promise<ArrayBuffer>}
 */
export async function getRemoteArrayBuffer(url) {
  const res = await resourceRequest.get(url, { responseType: 'arraybuffer' })
  return res.data
}

/**
 * 通过 HEAD 请求读取远程文件大小（字节）。
 * content-length 属于 CORS 安全响应头，跨域也能读到；服务端没返回时得到 null。
 * @param {string} url 文件完整地址
 * @returns {Promise<number|null>}
 */
export async function getRemoteContentLength(url) {
  const res = await resourceRequest.head(url)
  const length = Number(res.headers['content-length'])
  return Number.isFinite(length) && length > 0 ? length : null
}

/**
 * 读取构建时生成的 version.json（与页面同源的静态文件）。
 * XHR 不支持 fetch 的 cache: 'no-store'，用时间戳参数 + no-cache 请求头确保
 * CDN 与浏览器都不会返回缓存；同源请求加这两个头不会触发 CORS 预检问题。
 * @returns {Promise<Object>}
 */
export async function getAppVersionFile() {
  const res = await resourceRequest.get(`${process.env.BASE_URL}version.json`, {
    params: { t: Date.now() },
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
  })
  return res.data
}
